import { createContext, useContext } from 'react';

export const SchedulesContext = createContext({});

export function useSchedules() {
  return useContext(SchedulesContext);
}
